import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiLoader } from 'react-icons/fi';
import { apiService } from '../../components/Config/api.service';
import { BOUTON_PRINCIPAL, BOUTON_SECONDAIRE, enveloppeDe } from './organigrammeOutils';

/**
 * Créer le compte Portail d'un salarié et l'inviter (contrat C33,
 * Yros/Kavero#470), depuis sa fiche ou depuis un aperçu de l'organigramme.
 *
 * L'adresse de la fiche est proposée ; la RH la saisit si elle manque, ou la
 * corrige. Seule une adresse changée part au serveur, qui l'enregistre sur la
 * fiche — et l'oublie si l'invitation échoue. `emailConnu` absent (aperçu de
 * l'organigramme), l'adresse est lue sur le serveur.
 */
function InvitationPortail({ employeId, emailConnu, onInvite, onAnnuler }) {
  const { t } = useTranslation();
  const [initiale, setInitiale] = useState(emailConnu ?? null);
  const [saisie, setSaisie] = useState(emailConnu || '');
  const [erreur, setErreur] = useState('');
  const [enCours, setEnCours] = useState(false);

  useEffect(() => {
    if (emailConnu !== undefined) return undefined;
    let actif = true;
    enveloppeDe(() => apiService.lireComptePortail(employeId)).then((reponse) => {
      if (actif && reponse.ok) {
        setInitiale(reponse.compte.email);
        setSaisie(reponse.compte.email || '');
      }
    });
    return () => { actif = false; };
  }, [employeId, emailConnu]);

  const envoyer = async (evenement) => {
    evenement.preventDefault();
    const email = saisie.trim();
    setErreur('');
    setEnCours(true);
    const reponse = await enveloppeDe(
      () => apiService.inviterComptePortail(employeId, email === initiale ? null : email));
    setEnCours(false);
    if (reponse.ok) {
      onInvite(reponse.compte);
    } else {
      setErreur(reponse.message || t('comptePortail.erreurGenerique'));
    }
  };

  const champ = `invitation-portail-${employeId}`;
  return (
    <form onSubmit={envoyer} className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm">
      <label htmlFor={champ} className="block text-xs text-gray-600">{t('comptePortail.adresse')}</label>
      <input id={champ} type="email" value={saisie} onChange={(e) => setSaisie(e.target.value)}
        className="input input-bordered input-sm mt-1 w-full" autoComplete="off" />
      <p className="mt-1 text-xs text-gray-500">{t('comptePortail.adresseAide')}</p>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <button type="submit" className={BOUTON_PRINCIPAL} disabled={!saisie.trim() || enCours}>
          {enCours && <FiLoader className="animate-spin" />} {t('comptePortail.envoyer')}
        </button>
        <button type="button" className={BOUTON_SECONDAIRE} disabled={enCours} onClick={onAnnuler}>
          {t('comptePortail.annuler')}
        </button>
      </div>
      {erreur && (
        <p role="alert" className="mt-3 rounded border border-red-200 bg-red-50 p-2 text-red-700">{erreur}</p>
      )}
    </form>
  );
}

export default InvitationPortail;
